var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishedStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 25V35.5C28.5 35.85 28.315 36.18 28.015 36.36C27.855 36.455 27.68 36.5 27.5 36.5C27.335 36.5 27.175 36.46 27.025 36.38L21 33.135L14.975 36.38C14.665 36.545 14.29 36.54 13.985 36.36C13.685 36.18 13.5 35.85 13.5 35.5V25C13.5 24.45 13.95 24 14.5 24H27.5C28.05 24 28.5 24.45 28.5 25Z",
    fill: "url(#paint0_linear_1205_29445)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 17C31.5 17.76 31.42 18.5 31.265 19.21C30.335 23.545 26.73 26.89 22.265 27.42C21.85 27.475 21.43 27.5 21 27.5C15.205 27.5 10.5 22.795 10.5 17C10.5 11.205 15.205 6.5 21 6.5C26.795 6.5 31.5 11.205 31.5 17Z",
    fill: "url(#paint1_linear_1205_29445)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2652 19.21C30.3352 23.545 26.7302 26.89 22.2652 27.42L17.0752 22.23L17.5002 22.175L20.6202 19.62L18.7252 17.725L22.0302 11.245L26.0052 15.22L26.7052 14.645L31.2652 19.21Z",
    fill: "url(#paint2_linear_1205_29445)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5599 13.858L19.6584 11.6625C19.9124 11.1545 20.4319 10.8335 20.9999 10.8335C21.5679 10.8335 22.0874 11.1545 22.3414 11.6625L23.4399 13.858L25.8674 14.224C26.4289 14.309 26.8944 14.7035 27.0699 15.244C27.2454 15.784 27.1009 16.377 26.6964 16.776L24.9479 18.499L25.3494 20.921C25.4424 21.481 25.2109 22.046 24.7514 22.38C24.2919 22.7135 23.6834 22.7595 23.1789 22.498L20.9999 21.3675L18.8209 22.498C18.3164 22.7595 17.7079 22.7135 17.2484 22.38C16.7889 22.046 16.5574 21.481 16.6504 20.921L17.0519 18.499L15.3034 16.776C14.8989 16.377 14.7544 15.784 14.9299 15.244C15.1054 14.7035 15.5709 14.309 16.1324 14.224L18.5599 13.858Z",
    fill: "#FEF156"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5.5C27.347 5.5 32.5 10.653 32.5 17C32.5 23.347 27.347 28.5 21 28.5C14.653 28.5 9.5 23.347 9.5 17C9.5 10.653 14.653 5.5 21 5.5ZM21 7.5C15.757 7.5 11.5 11.757 11.5 17C11.5 22.243 15.757 26.5 21 26.5C26.243 26.5 30.5 22.243 30.5 17C30.5 11.757 26.243 7.5 21 7.5Z",
    fill: "url(#paint3_linear_1205_29445)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1205_29445",
    x1: 21,
    y1: 36.5,
    x2: 21,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5821,
    stopColor: "#02C0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8247,
    stopColor: "#27A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1205_29445",
    x1: 21,
    y1: 6.5,
    x2: 21,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5167,
    stopColor: "#FFC242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    stopColor: "#FFBE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7379,
    stopColor: "#FEB241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8466,
    stopColor: "#FE9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#FD8340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC753F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1205_29445",
    x1: 30.1432,
    y1: 26.6905,
    x2: 20.1092,
    y2: 16.6565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2058,
    stopColor: "#F99E0D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3182,
    stopColor: "#F49020",
    stopOpacity: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#E86D50",
    stopOpacity: 0.233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6405,
    stopColor: "#E25D66",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1205_29445",
    x1: 9.5,
    y1: 17,
    x2: 32.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4469,
    stopColor: "#FFC242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC753F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedStep);
export default __webpack_public_path__ + "static/media/finished_step.7d1e502966e8c1f74afadab45b710d25.svg";
export { ForwardRef as ReactComponent };